import { ThresholdData } from '@cmps/ng-kit';

import { bgGradient } from '../../common/pipe/bg-gradient';
import { MyCoachingCardGroup } from '../models/my-coaching-card-group.model';
import { StagingKpiThreshold } from '../models/staging-kpi-threshold.model';

export function getThresholdData(
    oaSummaryItem: MyCoachingCardGroup,
    coachingCardThreshold: StagingKpiThreshold[],
): ThresholdData[] {
    const baseTarget = oaSummaryItem.target * 100;
    const thresholdOne =
        coachingCardThreshold[0] != null
            ? baseTarget * coachingCardThreshold[0].rangeEnd
            : 0;
    const thresholdTwo =
        coachingCardThreshold[1] != null
            ? baseTarget * coachingCardThreshold[1].rangeEnd
            : 0;
    const score = oaSummaryItem.score * 100;

    const thresholds: ThresholdData[] = [
        {
            color: coachingCardThreshold[0]?.rangeColour ?? '#000000',
            colorGradient: bgGradient({
                color: coachingCardThreshold[0]?.rangeColour ?? '#000000',
            }),
            startValue: 0,
            endValue: thresholdOne,
            enabled: score >= 0 && score < thresholdOne,
        },
        {
            color: coachingCardThreshold[1]?.rangeColour ?? '#000000',
            colorGradient: bgGradient({
                color: coachingCardThreshold[1]?.rangeColour ?? '#000000',
            }),
            startValue: thresholdOne,
            endValue: thresholdTwo,
            enabled: score >= thresholdOne && score < thresholdTwo,
        },
        {
            color: coachingCardThreshold[2]?.rangeColour ?? '#000000',
            colorGradient: bgGradient({
                color: coachingCardThreshold[2]?.rangeColour ?? '#000000',
            }),
            startValue: thresholdTwo,
            endValue: 100,
            enabled: score >= thresholdTwo,
        },
    ];

    return thresholds;
}
